import styled from "styled-components";

export const StyledH1 = styled.h1`
  letter-spacing: normal;
  color: #264445;
  font-style: normal;
  font-weight: 500;
  font-size: 46px;
  line-height: 62px;
  text-align: center;
  text-align: ${(p) => p.textAlign && p.textAlign};
  max-width: ${(p) => (p.maxWidth ? p.maxWidth : "100%")};
  @media (max-width: 768px) {
    line-height: normal;
    font-size: 40px;
    text-align: center;
  }
  @media (max-width: 425px) {
    font-size: 28px;
    text-align: center;
  }
`;
